export default {
	'error_valid_max_length': 'Up to :maxLength characters',
	'error_valid_min_length': 'Up to :minLength characters',
	'error_valid_required_fields': 'Field must be filled',
	'error_valid_email_incorrect': 'Email is incorrect',
	'error_valid_wrong_pass': 'The password should be 8-30 characters long and include uppercase and lowercase Latin letters, numbers, and symbols. Acceptable symbols include ! @ # $ % ^ & * () ; "\' _ - . ,".',
	'error_valid_format_birth': 'Date of birth format dd-mm-yyyy',
	'error_valid_regexp_name': 'Allowed characters include Latin letters, as well as hyphens and apostrophes',
	'error_valid_field_length': 'The field should have a minimum of 2 and a maximum of 30 characters',
	'error_valid_phone_min_length': 'The phone number must be at least :minLength characters long',
	'error_valid_phone_max_length': 'The phone number cannot exceed :maxLength characters',
	'error_valid_email_min_length': 'The email address should be at least :minLength characters long',
	'error_valid_email_max_length': ' The email address cannot exceed :maxLength characters',

	permission_denied_title: 'Access Denied',
	permission_denied_text: 'You do not have permission to access this page.',
};
